import {HttpMethod, HttpService} from "./HttpService";

export interface DateRange {
    since: string;
    until: string;
}

export interface AdGroup {
    id: string;
    name: string;
    campaignId: string;
    status: string;

    // Budget information
    dailyBudget: number;
    lifetimeBudget: number;

    // Basic metrics
    spent: number;
    impressions: number;
    reach: number;

    // Click metrics
    clicks: number;
    uniqueClicks: number;
    inlineLinkClicks: number;
    linkClicks: number;

    // Cost metrics
    cpm: number;
    ctr: number;
    ctrLink: number;
    costPerUniqueClick: number;
    costPerInlineLinkClick: number;
    costPerLinkClick: number;

    // Conversion metrics
    leads: number;
    leadFormOpens: number;
    conversions: number;
    purchases: number;
    purchaseValue: number;

    // Return metrics
    roas: number;

    // Cost per conversion metrics
    costPerLead: number;
    costPerPurchase: number;

    // Facebook tracking - legacy naming for backward compatibility
    realLeads: number;
    realCostPerLead: number;
    realWatches: number;
    realInitTransactions: number;
    realPurchases: number;
    realPurchaseValue: number;
    realRoas: number;
    
    // Extended tracking with source information
    realLeadsFirstSource: number;
    realLeadsLastSource: number;
    realWatchesFirstSource: number;
    realWatchesLastSource: number;
    realInitTransactionsFirstSource: number;
    realInitTransactionsLastSource: number;
    realPurchasesFirstSource: number;
    realPurchasesLastSource: number;
    realPurchasesFirstSourceValue: number;
    realPurchasesLastSourceValue: number;
    realRoasFirstSource: number;
    realRoasLastSource: number;
    realCostPerLeadFirstSource: number;
    realCostPerLeadLastSource: number;
}

export interface AdCampaign {
    id: string;
    name: string;
    status: string;
    objective: string;

    // Budget information
    dailyBudget?: number;
    lifetimeBudget?: number;

    // Basic metrics
    spent: number;
    impressions: number;
    reach: number;

    // Click metrics
    clicks: number;
    uniqueClicks: number;
    inlineLinkClicks: number;
    linkClicks: number;

    // Cost metrics
    cpm: number;
    ctr: number;
    ctrLink: number;
    costPerUniqueClick: number;
    costPerInlineLinkClick: number;
    costPerLinkClick: number;

    // Conversion metrics
    leads: number;
    leadFormOpens: number;
    conversions: number;
    purchases: number;
    purchaseValue: number;

    // Return metrics
    roas: number;

    // Cost per conversion metrics
    costPerLead: number;
    costPerPurchase: number;

    // Video metrics
    videoP25Watched?: number;
    videoP50Watched?: number;
    videoP75Watched?: number;
    videoP100Watched?: number;

    // Debug information
    rawInsightsSample?: string;

    // Ad sets (ad groups) for this campaign
    adSets?: AdGroup[];

    // Facebook tracking - legacy naming for backward compatibility
    realLeads: number;
    realCostPerLead: number;
    realWatches: number;
    realInitTransactions: number;
    realPurchases: number;
    realPurchaseValue: number;
    realRoas: number;
    
    // Extended tracking with source information
    realLeadsFirstSource: number;
    realLeadsLastSource: number;
    realWatchesFirstSource: number;
    realWatchesLastSource: number;
    realInitTransactionsFirstSource: number;
    realInitTransactionsLastSource: number;
    realPurchasesFirstSource: number;
    realPurchasesLastSource: number;
    realPurchasesFirstSourceValue: number;
    realPurchasesLastSourceValue: number;
    realRoasFirstSource: number;
    realRoasLastSource: number;
    realCostPerLeadFirstSource: number;
    realCostPerLeadLastSource: number;
}

// Define tracking source types
export type TrackingSourceType = 'facebook' | 'firstSource' | 'lastSource';

export class MetaService {
    public static getAdsCampaigns(dateRange?: DateRange): Promise<AdCampaign[]> {
        let url = '/6da7a1eb-7810-4b02-8945-03804f411d1e';

        // Add date range parameters if provided
        if (dateRange) {
            url += `?since=${dateRange.since}&until=${dateRange.until}`;
        }

        return HttpService.sendRequest<AdCampaign[]>(
            HttpMethod.GET,
            url
        );
    }
}
